
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">Device</div>
          <div class="card-body"><pre>{{entity?.toJson(options) | json}}</pre></div>
        </div>
      </div>
    </div>
    